/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';

import { InputTextarea } from 'primereact/inputtextarea';
import { AutoComplete } from 'primereact/autocomplete';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';

import LoadingScreen from 'src/components/LoadingScreen';
import DropzoneScreen from 'src/components/Dropzone/Dropzone';
import { useFormCreateProducts } from '../../controllers/Products/CreateProductsController';
import { useFormCreateProductBrands } from 'src/controllers/ProductBrands/CreateProductBrandsController';
import { useFormCreateProductGroup } from 'src/controllers/ProductGroups/CreateProductGroupsController';
import { useFormCreateProductSubgroups } from 'src/controllers/ProductSubgroups/CreateProductSubgroupsController';
import { useData } from 'src/contexts/data';

interface filteredFieldProps {
	grupo?: string;
	label?: string;
	value?: string;
}

const ProductForm: React.FC = () => {
	const { handleDelete } = useData();

	const { getController, handleController } = useFormCreateProducts();
	const { getProductBrandFormController } = useFormCreateProductBrands();
	const { getProductGroupFormController } = useFormCreateProductGroup();
	const { getProductSubgroupFormController } = useFormCreateProductSubgroups();

	const [filteredBrands, setFilteredBrands] = useState<filteredFieldProps[]>([{ label: '', value: '' }]);
	const [filteredGroups, setFilteredGroups] = useState<filteredFieldProps[]>([{ label: '', value: '' }]);
	const [filteredSubgroups, setFilteredSubgroups] = useState<filteredFieldProps[]>([{}]);

	const [ProductBrandResponse, setProductBrandResponse] = useState<any[]>([]);
	const [ProductGroupResponse, setProductGroupResponse] = useState<any[]>([]);
	const [ProductSubgroupResponse, setProductSubgroupResponse] = useState<any[]>([]);

	const [ProductBrandsValue, setProductBrandsValue] = useState('');
	const [ProductGroupsValue, setProductGroupsValue] = useState('');
	const [ProductGroupsID, setProductGroupsID] = useState('');
	const [ProductSubgroupsValue, setProductSubgroupsValue] = useState('');

	const [registerFinished, setRegisterFinished] = useState(false);

	const history = useHistory();

	useEffect(() => {
		if (getController.productsResponse?.status === 200) {
			setRegisterFinished(true);
		}
		if (getController.productsEditedResponse?.status === 200 && !getController.productsResponse) {
			setRegisterFinished(false);
			setProductBrandsValue('');
			setProductGroupsValue('');
			setProductSubgroupsValue('');
		}
		if (getProductBrandFormController.ProductbrandResponse?.status === 200) updateProductBrands();
		if (getProductGroupFormController.ProductGroupResponse?.status === 200) updateProductGroups();
		if (getProductSubgroupFormController.ProductSubgroupResponse?.status === 200) updateProductSubgroups();
	}, [
		getController.productsResponse,
		getController.productsEditedResponse,
		getProductBrandFormController.ProductbrandResponse,
		getProductGroupFormController.ProductGroupResponse,
		getProductSubgroupFormController.ProductSubgroupResponse,
	]);

	const brands = getController.tablesData.brandsData.map(brand => {
		return { label: brand.DESCRICAO, value: brand.ID };
	});
	const groups = getController.tablesData.groupsData.map(group => {
		return { label: group.DESCRICAO, value: group.ID };
	});
	const subgroups = getController.tablesData.subgroupsData.map(subgroup => {
		return { label: subgroup.DESCSUBGRUPO, value: subgroup.ID, grupo: subgroup.AX_GRUPO };
	});

	const searchBrand = (event: any) => {
		let filteredBrands;
		if (!event.query.trim().length) {
			filteredBrands = [...brands];
		} else {
			filteredBrands = brands.filter(brand => {
				return brand.label.toLowerCase().includes(event.query.toLowerCase());
			});
		}
		setFilteredBrands(filteredBrands);
	};

	const searchGroup = (event: any) => {
		let filteredGroups;
		if (!event.query.trim().length) {
			filteredGroups = [...groups];
		} else {
			filteredGroups = groups.filter(group => {
				return group.label.toLowerCase().includes(event.query.toLowerCase());
			});
		}
		setFilteredGroups(filteredGroups);
	};

	const searchSubgroup = (event: any) => {
		let filteredSubgroups;
		if (!event.query.trim().length) {
			filteredSubgroups = [...subgroups];
		} else {
			filteredSubgroups = subgroups.filter(subgroup => {
				return (
					subgroup.label?.toLowerCase().includes(event.query.toLowerCase()) &&
					subgroup.grupo === ProductGroupsID
				);
			});
		}

		setFilteredSubgroups(filteredSubgroups);
	};

	const updateProductBrands = () => {
		handleController.closeFormDialog();
		let ProductBrandUpdate = {
			label: getProductBrandFormController.ProductbrandResponse?.data.DESCRICAO,
			value: getProductBrandFormController.ProductbrandResponse?.data.ID,
		};
		let ProductBrandList = [...ProductBrandResponse, ProductBrandUpdate];
		if (!!ProductBrandUpdate.value) {
			setProductBrandResponse(ProductBrandList);
			setProductBrandsValue(ProductBrandList[0].label);
			getController.formik.setFieldValue('MARCA', ProductBrandList[0].value);
		}
	};

	const updateProductGroups = () => {
		handleController.closeFormDialog();
		let ProductGroupUpdate = {
			label: getProductGroupFormController.ProductGroupResponse?.data.DESCRICAO,
			value: getProductGroupFormController.ProductGroupResponse?.data.ID,
		};
		let ProductGroupList = [...ProductGroupResponse, ProductGroupUpdate];
		if (!!ProductGroupUpdate.value) {
			setProductGroupResponse(ProductGroupList);
			setProductGroupsValue(ProductGroupList[0].label);
			getController.formik.setFieldValue('AX_GRUPO', ProductGroupList[0].value);
		}
	};

	const updateProductSubgroups = () => {
		handleController.closeFormDialog();
		let ProductSubgroupUpdate = {
			label: getProductSubgroupFormController.ProductSubgroupResponse?.data.DESCRICAO,
			value: getProductSubgroupFormController.ProductSubgroupResponse?.data.ID,
		};
		let ProductSubgroupList = [...ProductSubgroupResponse, ProductSubgroupUpdate];
		if (!!ProductSubgroupUpdate.value) {
			setProductSubgroupResponse(ProductSubgroupList);
			setProductSubgroupsValue(ProductSubgroupList[0].label);
			getController.formik.setFieldValue('AX_GRUPOSUB', ProductSubgroupList[0].value);
		}
	};

	const extraFormDialogHeader = (
		<div className='p-fluid p-d-flex p-flex-row p-jc-between'>
			<div>
				<h5>Cadastrar {getController.selectedField}</h5>
			</div>
			<div>
				<Button
					label='Fechar'
					icon='pi pi-times'
					className='p-button-text p-fluid'
					onClick={handleController.closeFormDialog}
				/>
			</div>
		</div>
	);

	return (
		<form style={{ height: '100%' }} className='card p-align-center p-justify-center'>
			{getController.loading ? <LoadingScreen color='#0388e5' /> : <></>}
			<Toast ref={getController.toast} />
			<Toast ref={getProductBrandFormController.toast} />
			<Toast ref={getProductGroupFormController.toast} />
			<Toast ref={getProductSubgroupFormController.toast} />
			<h5>Cadastro de produto</h5>
			<div className='p-grid p-fluid'>
				<div className='p-field p-col-12 p-md-6'>
					<label htmlFor='descricao'>Descrição</label>
					<InputText
						disabled={registerFinished}
						id='descricao'
						maxLength={150}
						{...getController.formik.getFieldProps('DESCRICAO')}
						onChange={getController.formik.handleChange('DESCRICAO')}
					/>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getController.formik.touched.DESCRICAO && getController.formik.errors.DESCRICAO,
							'popup-form-inactive': !(
								getController.formik.touched.DESCRICAO && getController.formik.errors.DESCRICAO
							),
						})}>
						{getController.formik.errors.DESCRICAO}
					</div>
				</div>

				<div className='p-field p-col-12 p-md-6'>
					<label htmlFor='marca'>Marca</label>
					<div className='p-inputgroup'>
						<Button
							type='button'
							icon='pi pi-plus'
							className='p-button-primary '
							onClick={() => handleController.openFormDialog('Marca')}
						/>
						<AutoComplete
							disabled={registerFinished}
							id='marca'
							dropdown
							placeholder='Buscar...'
							value={ProductBrandsValue}
							onChange={e => {
								setProductBrandsValue(e.value);
								getController.formik.setFieldValue(
									'MARCA',
									filteredBrands.find(role => {
										return e.value === role.label;
									})?.value || '',
								);
							}}
							onSelect={e => {
								getController.formik.setFieldValue('MARCA', e.value.value);
								setProductBrandsValue(e.value.label);
							}}
							suggestions={filteredBrands}
							field='label'
							completeMethod={searchBrand}
						/>
					</div>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getController.formik.touched.MARCA && getController.formik.errors.MARCA,
							'popup-form-inactive': !(
								getController.formik.touched.MARCA && getController.formik.errors.MARCA
							),
						})}>
						{getController.formik.errors.MARCA}
					</div>
				</div>

				<div className='p-field p-col-12 p-md-6'>
					<label htmlFor='descricaoComp'>Descrição completa</label>
					<InputTextarea
						disabled={registerFinished}
						rows={6}
						id='descricaoComp'
						maxLength={500}
						{...getController.formik.getFieldProps('DESCRICAOCOMPLETA')}
						autoResize
						onChange={getController.formik.handleChange('DESCRICAOCOMPLETA')}
					/>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getController.formik.touched.DESCRICAOCOMPLETA &&
								getController.formik.errors.DESCRICAOCOMPLETA,
							'popup-form-inactive': !(
								getController.formik.touched.DESCRICAOCOMPLETA &&
								getController.formik.errors.DESCRICAOCOMPLETA
							),
						})}>
						{getController.formik.errors.DESCRICAOCOMPLETA}
					</div>
				</div>

				<div className='p-grid p-col-12 p-md-6'>
					<div className='p-field p-col-12'>
						<label htmlFor='codBarras'>Código de barras</label>
						<InputText
							disabled={registerFinished}
							id='codBarras'
							maxLength={100}
							{...getController.formik.getFieldProps('CODIGOBARRAS')}
							onChange={getController.formik.handleChange('CODIGOBARRAS')}
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getController.formik.touched.CODIGOBARRAS &&
									getController.formik.errors.CODIGOBARRAS,
								'popup-form-inactive': !(
									getController.formik.touched.CODIGOBARRAS &&
									getController.formik.errors.CODIGOBARRAS
								),
							})}>
							{getController.formik.errors.CODIGOBARRAS}
						</div>
					</div>

					<div className='p-field p-col-12'>
						<label htmlFor='ncm'>NCM/SH</label>
						<InputText
							disabled={registerFinished}
							id='ncm'
							maxLength={8}
							{...getController.formik.getFieldProps('NCM')}
							onChange={getController.formik.handleChange('NCM')}
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getController.formik.touched.NCM && getController.formik.errors.NCM,
								'popup-form-inactive': !(
									getController.formik.touched.NCM && getController.formik.errors.NCM
								),
							})}>
							{getController.formik.errors.NCM}
						</div>
					</div>
				</div>

				<div className='p-field p-col-6 p-md-3'>
					<label htmlFor='grupo'>Grupo</label>
					<div className='p-inputgroup'>
						<Button
							type='button'
							icon='pi pi-plus'
							className='p-button-primary '
							onClick={() => handleController.openFormDialog('Grupo')}
						/>
						<AutoComplete
							disabled={registerFinished}
							id='grupo'
							dropdown
							placeholder='Buscar...'
							value={ProductGroupsValue}
							onChange={e => {
								setProductGroupsValue(e.value);
								getController.formik.setFieldValue(
									'AX_GRUPO',
									filteredGroups.find(group => {
										return e.value === group.label;
									})?.value || '',
								);
							}}
							onSelect={e => {
								getController.formik.setFieldValue('AX_GRUPO', e.value.value);
								setProductGroupsValue(e.value.label);
								setProductGroupsID(e.value.value);
							}}
							suggestions={filteredGroups}
							field='label'
							completeMethod={searchGroup}
						/>
					</div>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getController.formik.touched.AX_GRUPO && getController.formik.errors.AX_GRUPO,
							'popup-form-inactive': !(
								getController.formik.touched.AX_GRUPO && getController.formik.errors.AX_GRUPO
							),
						})}>
						{getController.formik.errors.AX_GRUPO}
					</div>
				</div>

				<div className='p-field p-col-6 p-md-3'>
					<label htmlFor='subgrupo'>Subgrupo</label>
					<div className='p-inputgroup'>
						<Button
							type='button'
							icon='pi pi-plus'
							className='p-button-primary '
							onClick={() => handleController.openFormDialog('Subgrupo')}
						/>

						<AutoComplete
							disabled={registerFinished}
							id='subgrupo'
							dropdown
							placeholder='Buscar...'
							value={ProductSubgroupsValue}
							onChange={e => {
								setProductSubgroupsValue(e.value);
								getController.formik.setFieldValue(
									'AX_GRUPOSUB',
									filteredSubgroups.find(subgroup => {
										return e.value === subgroup.label;
									})?.value || '',
								);
							}}
							onSelect={e => {
								getController.formik.setFieldValue('AX_GRUPOSUB', e.value.value);
								setProductSubgroupsValue(e.value.label);
							}}
							suggestions={filteredSubgroups.filter(subgroup => {
								return subgroup.grupo === ProductGroupsID;
							})}
							field='label'
							completeMethod={searchSubgroup}
						/>
					</div>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getController.formik.touched.AX_GRUPOSUB && getController.formik.errors.AX_GRUPOSUB,
							'popup-form-inactive': !(
								getController.formik.touched.AX_GRUPOSUB && getController.formik.errors.AX_GRUPOSUB
							),
						})}>
						{getController.formik.errors.AX_GRUPOSUB}
					</div>
				</div>

				<div className='p-field p-col-6 p-md-3'>
					<label htmlFor='ultCompra'>Último valor de compra</label>
					<InputNumber
						disabled={registerFinished}
						id='ultCompra'
						{...getController.formik.getFieldProps('ULTIMOVALORCOMPRA')}
						onChange={e => getController.formik.setFieldValue('ULTIMOVALORCOMPRA', e.value)}
						mode='currency'
						currency='BRL'
						locale='pt-BR'
					/>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getController.formik.touched.ULTIMOVALORCOMPRA &&
								getController.formik.errors.ULTIMOVALORCOMPRA,
							'popup-form-inactive': !(
								getController.formik.touched.ULTIMOVALORCOMPRA &&
								getController.formik.errors.ULTIMOVALORCOMPRA
							),
						})}>
						{getController.formik.errors.ULTIMOVALORCOMPRA}
					</div>
				</div>

				<div className='p-field p-col-6 p-md-3'>
					<label htmlFor='ultVenda'>Último valor de venda</label>
					<InputNumber
						disabled={registerFinished}
						id='ultVenda'
						{...getController.formik.getFieldProps('ULTIMOVALORVENDA')}
						onChange={e => getController.formik.setFieldValue('ULTIMOVALORVENDA', e.value)}
						mode='currency'
						currency='BRL'
						locale='pt-BR'
					/>
					<div
						className={classNames('p-invalid popup-fade', {
							'popup-form-active':
								getController.formik.touched.ULTIMOVALORVENDA &&
								getController.formik.errors.ULTIMOVALORVENDA,
							'popup-form-inactive': !(
								getController.formik.touched.ULTIMOVALORVENDA &&
								getController.formik.errors.ULTIMOVALORVENDA
							),
						})}>
						{getController.formik.errors.ULTIMOVALORVENDA}
					</div>
				</div>

				<div className='p-field p-col-12'>
					<label htmlFor='ultVenda'>Foto do produto</label>
					<div
						style={registerFinished ? { pointerEvents: 'none', opacity: 0.5 } : {}}
						className='p-fileupload'>
						<DropzoneScreen />
					</div>
				</div>
			</div>

			<div className='p-fluid p-grid p-justify-between'>
				{getController.productsResponse?.status === 200 && !registerFinished ? (
					<div className='p-col-12 p-md-4'>
						<Button
							type='button'
							label='Salvar Alterações'
							onClick={() => {
								getController.formik.handleSubmit();
							}}
						/>
					</div>
				) : getController.productsResponse?.status === 200 && registerFinished ? (
					<div className='p-col-12 p-md-6 p-fluid p-grid'>
						<div className='p-col-12 p-md-5'>
							<Button
								type='button'
								label='Editar'
								onClick={() => {
									setRegisterFinished(false);
								}}
							/>
						</div>
						<div className='p-col-12 p-md-5'>
							<Button
								icon='pi pi-plus'
								type='button'
								className='p-button-success'
								label='Cadastrar novo'
								onClick={() => {
									getController.formik.resetForm();
									setProductBrandsValue('');
									setProductGroupsValue('');
									setProductSubgroupsValue('');
									setRegisterFinished(false);
									handleController.setProductsResponse(null);
									handleDelete();
								}}
							/>
						</div>
					</div>
				) : (
					<div className='p-col-12 p-md-4'>
						<Button type='button' label='Cadastrar' onClick={() => getController.formik.handleSubmit()} />
					</div>
				)}

				<div className='p-col-12 p-md-4'>
					<Button
						type='button'
						className='p-button-secondary'
						label='Voltar para listagem'
						onClick={() => history.goBack()}
					/>
				</div>
			</div>

			<Dialog
				style={{ width: '450px' }}
				contentStyle={{ height: '100%' }}
				visible={getController.formDialog && getController.selectedField === 'Marca'}
				onHide={updateProductBrands}
				header={extraFormDialogHeader}
				closable={false}
				modal>
				<div
					className='confirmation-content p-fluid p-d-flex p-flex-column p-jc-between'
					style={{ height: '100%' }}>
					<div className='p-field'>
						<label htmlFor='marca'>Nome</label>
						<InputText
							id='marca'
							type='text'
							value={getProductBrandFormController.formik.values.DESCRICAO}
							onChange={getProductBrandFormController.formik.handleChange('DESCRICAO')}
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getProductBrandFormController.formik.touched.DESCRICAO &&
									getProductBrandFormController.formik.errors.DESCRICAO,
								'popup-form-inactive': !(
									getProductBrandFormController.formik.touched.DESCRICAO &&
									getProductBrandFormController.formik.errors.DESCRICAO
								),
							})}>
							{getProductBrandFormController.formik.errors.DESCRICAO}
						</div>
					</div>
					<Button
						type='submit'
						label='Cadastrar'
						onClick={() => getProductBrandFormController.formik.handleSubmit()}
					/>
				</div>
				{getProductBrandFormController.loading ? <LoadingScreen color='#0388e5' /> : <></>}
			</Dialog>

			<Dialog
				style={{ width: '450px' }}
				contentStyle={{ height: '100%' }}
				visible={getController.formDialog && getController.selectedField === 'Grupo'}
				onHide={updateProductGroups}
				header={extraFormDialogHeader}
				closable={false}
				modal>
				<div
					className='confirmation-content p-fluid p-d-flex p-flex-column p-jc-between'
					style={{ height: '100%' }}>
					<div className='p-field'>
						<label htmlFor='grupo'>Nome</label>
						<InputText
							id='grupo'
							type='text'
							value={getProductGroupFormController.formik.values.DESCRICAO}
							onChange={getProductGroupFormController.formik.handleChange('DESCRICAO')}
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getProductGroupFormController.formik.touched.DESCRICAO &&
									getProductGroupFormController.formik.errors.DESCRICAO,
								'popup-form-inactive': !(
									getProductGroupFormController.formik.touched.DESCRICAO &&
									getProductGroupFormController.formik.errors.DESCRICAO
								),
							})}>
							{getProductGroupFormController.formik.errors.DESCRICAO}
						</div>
					</div>
					<Button
						type='submit'
						label='Cadastrar'
						onClick={() => getProductGroupFormController.formik.handleSubmit()}
					/>
				</div>
				{getProductGroupFormController.loading ? <LoadingScreen color='#0388e5' /> : <></>}
			</Dialog>

			<Dialog
				className='dropdown-visible'
				style={{ width: '450px' }}
				contentStyle={{ height: '100%' }}
				visible={getController.formDialog && getController.selectedField === 'Subgrupo'}
				onHide={updateProductBrands}
				header={extraFormDialogHeader}
				closable={false}
				modal>
				<div
					className='confirmation-content p-fluid p-d-flex p-flex-column p-jc-between'
					style={{ height: '100%' }}>
					<div className='p-field'>
						<label htmlFor='subgrupo'>Nome</label>
						<InputText
							id='subgrupo'
							type='text'
							value={getProductSubgroupFormController.formik.values.DESCRICAO}
							onChange={getProductSubgroupFormController.formik.handleChange('DESCRICAO')}
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getProductSubgroupFormController.formik.touched.DESCRICAO &&
									getProductSubgroupFormController.formik.errors.DESCRICAO,
								'popup-form-inactive': !(
									getProductSubgroupFormController.formik.touched.DESCRICAO &&
									getProductSubgroupFormController.formik.errors.DESCRICAO
								),
							})}>
							{getProductSubgroupFormController.formik.errors.DESCRICAO}
						</div>
					</div>
					<div className='p-field'>
						<label htmlFor='grupo'>Grupo</label>
						<AutoComplete
							id='grupo'
							value={ProductGroupsValue}
							field='label'
							onChange={e => {
								setProductGroupsValue(e.value);
								getProductSubgroupFormController.formik.setFieldValue(
									'AX_GRUPO',
									filteredGroups.find(group => {
										return e.value === group.label;
									})?.value || '',
								);
								getController.formik.setFieldValue(
									'AX_GRUPO',
									filteredGroups.find(group => {
										return e.value === group.label;
									})?.value || '',
								);
							}}
							onSelect={e => {
								setProductGroupsValue(e.value.label);
								getProductSubgroupFormController.formik.setFieldValue('AX_GRUPO', e.value.value);
								getController.formik.setFieldValue('AX_GRUPO', e.value.value);
							}}
							suggestions={filteredGroups}
							completeMethod={searchGroup}
							dropdown
							placeholder='Buscar...'
							dropdownMode='current'
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getProductSubgroupFormController.formik.touched.AX_GRUPO &&
									getProductSubgroupFormController.formik.errors.AX_GRUPO,
								'popup-form-inactive': !(
									getProductSubgroupFormController.formik.touched.AX_GRUPO &&
									getProductSubgroupFormController.formik.errors.AX_GRUPO
								),
							})}>
							{getProductSubgroupFormController.formik.errors.AX_GRUPO}
						</div>
					</div>
					<Button
						type='submit'
						label='Cadastrar'
						onClick={() => getProductSubgroupFormController.formik.handleSubmit()}
					/>
				</div>
				{getProductSubgroupFormController.loading ? <LoadingScreen color='#0388e5' /> : <></>}
			</Dialog>
		</form>
	);
};

export default ProductForm;
